/**
 * Set cart count from state.
 */
function updateCartCount() {
	if( 'undefined' !== typeof whippetState && whippetState.cartCount ) {
		document.querySelectorAll( '.whippet-cart-status' ).forEach( widget => {
			if( whippetState.cartCount > 9 ) {
				widget.innerHTML = '9+';
			} else {
				widget.innerHTML = whippetState.cartCount;
			}
		} )
	}
}

document.addEventListener( 'whippetStateChanged', updateCartCount )
updateCartCount(); // Update cart count on load in case state has loaded first
